// extracted by mini-css-extract-plugin
export default {"cells":"cells_cells__9ZnTI","cellsRowWrapper":"cells_cellsRowWrapper__dmIIo","cellsRow":"cells_cellsRow__kwZ+H"};